import { z } from 'zod';

export type DocumentCreateForm = {
    name: string,
    file: File,
};

export type DocumentCreateFormErrors = {
    name?: string[],
    file?: string[],
};

export type DocumentCreateRequestResult = {
    form: DocumentCreateForm,
    errors: DocumentCreateFormErrors | undefined,
};

export const DocumentCreateFormErrorsSchema = z.object({
    name: z.string().array().optional(),
    file: z.string().array().optional(),
});

export function mapDocumentCreateFormToFormData(createForm: DocumentCreateForm): FormData {
    const formData = new FormData();

    formData.append('name', createForm.name);
    formData.append('file', createForm.file);

    return formData;
}
